import { render, staticRenderFns } from "./changeInfo.vue?vue&type=template&id=be9a3cf0&"
import script from "./changeInfo.vue?vue&type=script&lang=js&"
export * from "./changeInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports